import React from "react";
import { Eye } from "lucide-react";

/**
 * Sticky banner shown on public pages when they are rendered from a CMS draft
 * (via `?preview=<key>` + sessionStorage). Fixed at the very top of the viewport
 * so admins always know they are looking at unsaved changes.
 */
const PreviewBanner = ({ label = "Draft preview" }) => (
  <div
    data-testid="preview-banner"
    className="fixed top-0 inset-x-0 z-[60] bg-primary text-primary-foreground shadow-md"
  >
    <div className="mx-auto max-w-[1400px] px-5 md:px-8 py-2.5 flex items-center gap-3">
      <Eye size={16} className="shrink-0" />
      <p className="font-mono text-xs uppercase tracking-widest font-bold">
        {label}
      </p>
      <p className="font-sans text-xs md:text-sm text-primary-foreground/85">
        You are viewing unsaved CMS changes — close this tab to dismiss, or Save in the
        editor tab to publish.
      </p>
    </div>
  </div>
);

export default PreviewBanner;
